import { useEffect, useState } from "react";
import { useNavigate } from "react-router"
import env from "react-dotenv"

function ForgottenPassword() {
    let navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Change background color
        document.body.style.backgroundColor = "#f8f9fe"
    }, [])

    function handleChangeEmail(event) {
        setUsername(event.target.value);
    }

    async function handleSubmit() {
        const res = await fetch(env.BACKEND_URL + "/admin/reset-password", {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "username=" + username,
        });

        if (res.ok)
            navigate("/email-sent");
        else if (res.status === 404)
            setErrorMessage("Adresse introuvable")
        else
            setErrorMessage("Erreur inattendue : " + await res.text());
    
    }


    return (
        <div>
            <div className="login">
                <div className="login-form">
                    <div className="login-error-text">
                        {errorMessage}
                    </div>

                    <div className="login-form-title">
                        E-MAIL
                    </div>
                    <div>
                        <input className="login-input-field" type="text" value={username} onChange={handleChangeEmail} />
                    </div>

                    <div>
                        <button className="button" onClick={handleSubmit}>Envoyer</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgottenPassword;